import { combineReducers } from 'redux';

import account from 'js/src/data/account';
import { announcements } from 'js/src/data/announcements/announcement-reducers';
import comments from 'js/src/data/comments';
import modals from 'js/src/data/modals';
import notifications from 'js/src/data/notifications';
import { pricingReducer as pricing } from 'js/src/data/pricing/pricing-slice';
import shareVideo from 'js/src/data/share-video';
import templates from 'js/src/data/templates';
import translations from 'js/src/data/translations';

export const getRootReducer = () => {
    return combineReducers({
        account,
        announcements,
        modals,
        shareVideo,
        comments,
        templates,
        translations,
        notifications,
        pricing,
    });
};
